import { useEffect, useState } from 'react';
import { getLeftTime } from 'swag-common/utils/date-lib';
export const useTimeLeftForLimitedEdition = (expirationDate, isLimitedEdition = true) => {
  const [leftTime, setLeftTime] = useState(getLeftTime(expirationDate));
  useEffect(() => {
    if (isLimitedEdition) {
      const timer = setInterval(() => {
        setLeftTime(getLeftTime(expirationDate));
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isLimitedEdition, expirationDate]);
  return isLimitedEdition ? leftTime : 0;
};